import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { SidebarContext } from "context/SidebarContext";
import NewsServices from "services/NewsServices";
import { notifyError, notifySuccess } from "utils/toast";


const UseNewsSubmit = (id) => {
    const { isDrawerOpen, closeDrawer, setIsUpdate } =
        useContext(SidebarContext);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [NewsUrl, setNewsUrl] = useState("");
    const {
        register,
        handleSubmit,
        setValue,
        reset,
        formState: { errors },
    } = useForm();
    useEffect(() => {
        if (!id) {
            reset();
            setNewsUrl("");
            return;
        }
        const fetchNews = async () => {
            try {
                const res = await NewsServices.getnewsByid(id);
                if (res?.data) {
                    setValue("title", res.data.title);
                    setValue("description", res.data.description);
                    // setValue("news_image", res.data.news_image || "");
                    setValue("url", res.data.url);
                    const image = res.data.news_image || "";
                    setValue("news_image", image);
                    setNewsUrl(image);
                }
            } catch (error) {
                notifyError("Failed to load news data");
            }
        };


        fetchNews();
    }, [id, setValue]);


    useEffect(() => {
        if (NewsUrl !== undefined) {
            setValue("news_image", NewsUrl);
        }
    }, [NewsUrl, setValue]);

    const onSubmit = async (data) => {

        try {
            setIsSubmitting(true);

            const newsData = {
                title: data.title,
                description: data.description,
                news_image: data.news_image,
                url: data.url,
            };

            if (id) {
                await NewsServices.updateNews(id, newsData);
                notifySuccess("news submitted Succesfully")
            } else {
                await NewsServices.addnews(newsData);
                notifySuccess("news submitted Succesfully")
            }
            setIsUpdate(true);
            closeDrawer();
            reset();
        } catch (error) {
            notifyError(error?.response?.data?.message || "Something went wrong");
        } finally {
            setIsSubmitting(false);
        }
    };

    useEffect(() => {
        if (!isDrawerOpen) {
            reset();
            setNewsUrl("");


        }
    }, [isDrawerOpen, reset]);

    return {
        register,
        handleSubmit,
        onSubmit,
        errors,
        isSubmitting,
        setValue,
        NewsUrl,
        setNewsUrl

    };
};

export default UseNewsSubmit;
